__turbopack_context__.v({
  "amount": "ProgramCard2-module-scss-module__UOGqXW__amount",
  "button": "ProgramCard2-module-scss-module__UOGqXW__button",
  "card_link": "ProgramCard2-module-scss-module__UOGqXW__card_link",
  "card_link_disabled": "ProgramCard2-module-scss-module__UOGqXW__card_link_disabled",
  "collab_label": "ProgramCard2-module-scss-module__UOGqXW__collab_label",
  "collab_logos": "ProgramCard2-module-scss-module__UOGqXW__collab_logos",
  "collab_overlay": "ProgramCard2-module-scss-module__UOGqXW__collab_overlay",
  "content_container": "ProgramCard2-module-scss-module__UOGqXW__content_container",
  "corporateCta": "ProgramCard2-module-scss-module__UOGqXW__corporateCta",
  "desc": "ProgramCard2-module-scss-module__UOGqXW__desc",
  "descMob": "ProgramCard2-module-scss-module__UOGqXW__descMob",
  "emptyDiv": "ProgramCard2-module-scss-module__UOGqXW__emptyDiv",
  "fee_detail": "ProgramCard2-module-scss-module__UOGqXW__fee_detail",
  "hcl_img": "ProgramCard2-module-scss-module__UOGqXW__hcl_img",
  "heading": "ProgramCard2-module-scss-module__UOGqXW__heading",
  "imageHidden": "ProgramCard2-module-scss-module__UOGqXW__imageHidden",
  "imageSkeleton": "ProgramCard2-module-scss-module__UOGqXW__imageSkeleton",
  "imageVisible": "ProgramCard2-module-scss-module__UOGqXW__imageVisible",
  "img_container": "ProgramCard2-module-scss-module__UOGqXW__img_container",
  "kpmgLogo": "ProgramCard2-module-scss-module__UOGqXW__kpmgLogo",
  "kpmg_img": "ProgramCard2-module-scss-module__UOGqXW__kpmg_img",
  "medvarsity_img": "ProgramCard2-module-scss-module__UOGqXW__medvarsity_img",
  "offerAmount": "ProgramCard2-module-scss-module__UOGqXW__offerAmount",
  "offerBox": "ProgramCard2-module-scss-module__UOGqXW__offerBox",
  "offerLabel": "ProgramCard2-module-scss-module__UOGqXW__offerLabel",
  "paytm_img": "ProgramCard2-module-scss-module__UOGqXW__paytm_img",
  "prgm_card_box": "ProgramCard2-module-scss-module__UOGqXW__prgm_card_box",
  "prgm_logo_container": "ProgramCard2-module-scss-module__UOGqXW__prgm_logo_container",
  "prgm_strip": "ProgramCard2-module-scss-module__UOGqXW__prgm_strip",
  "prgm_yellow_strip": "ProgramCard2-module-scss-module__UOGqXW__prgm_yellow_strip",
  "programCardImageShimmer": "ProgramCard2-module-scss-module__UOGqXW__programCardImageShimmer",
  "rics": "ProgramCard2-module-scss-module__UOGqXW__rics",
  "root": "ProgramCard2-module-scss-module__UOGqXW__root",
  "rootWithOffer": "ProgramCard2-module-scss-module__UOGqXW__rootWithOffer",
  "soai_img_container": "ProgramCard2-module-scss-module__UOGqXW__soai_img_container",
  "tcs_img": "ProgramCard2-module-scss-module__UOGqXW__tcs_img",
  "watch": "ProgramCard2-module-scss-module__UOGqXW__watch",
  "women_img": "ProgramCard2-module-scss-module__UOGqXW__women_img",
});
